// react
import React from 'react';

// third-party
import { Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import HomePage from './home/HomePage';

// application
import Footer from './footer';
import Header from './header';

import catalogos from '../data/catalogos';
import { typeTraslate } from '../data/enums';
import Catalogo from './shared/Catalogos';
import { _path } from '../data/headerNavigation';
import PrivateRoute from './header/PrivateRouter';
import Paciente from './search/Paciente';
import OutPutProducts from '../views/movimientos/outPutProducts';
import Products from '../views/products';
import Users from '../views/users';
import Roles from '../views/roles';
import Resources from '../views/resources';
import Rates from '../views/rates';
import initProduct from '../views/movimientos/initProducts/initProduct';
import Providers from '../views/providers/Providers';
import Traslates from '../views/movimientos/traslates';
import Kardex from '../views/reports/kardex';
import Existencias from '../views/reports/stocks';
import initAdjustments from '../views/movimientos/initProducts/initAdjustments';
import Clients from '../views/clients';
import Bills from '../views/bills';
import NotasCreditos from '../views/notascreditos';
import Receipts from '../views/receipts';
import Areas from '../views/areas';
import Vendors from '../views/vendors/Vendors';
import Stock from '../views/reports/stocks/Stock';
import Navig from './navigator/Navig';
import AppConfig from '../views/app/AppConfig';
import Comision from '../views/reports/facturas/Comision';
import ProductsInfo from '../views/reports/facturas/ProductsInfo';
import Clasifications from '../views/clasifications';
import Pending from '../views/clients/Pending';
import MobileMenu from './mobile/MobileMenu';
import MobileHeader from './mobile/MobileHeader';
import Cuts from '../views/cuts';
import Ejecute from '../views/cuts/Ejecute';
import Compras from '../views/reports/compras/Compras';
import Cotizaciones from '../views/prebills/Cotizaciones';
import PreVentas from '../views/prebills/PreVentas';
import Purchases from '../views/purchases';
import Authorizations from '../views/app/Authorizations';
import MobileCotizaciones from '../views/mobile/prebills/MobileCotizaciones';
import MobilePreVentas from '../views/mobile/prebills/PreVentas';
import ComisionFamilies from '../views/comisionFamilies/ComisionFamilies';
import Recibos from '../views/bills/Recibos';
import MobilePending from '../views/mobile/clients/MobilePending';
import ClientsMobile from '../views/clients/ClientsMobile';
import Ingresos from '../views/reports/stocks/Ingresos';
import DashboardSales from '../views/reports/stocks/DashboardSales';
import BillUpdates from '../views/bills/BillUpdates';
import ImageProduct from '../views/products/ImageProduct';
import StockByDate from '../views/reports/stockByDate/StockByDate';
import Goals from '../views/goals/Goals';
import Expenses from '../views/expenses/Expenses';
import ResultStete from '../views/reports/ResultStete';
import Mora from '../views/clients/Mora';
import Historial from '../views/clients/Historial';
import ReporteTabs from '../views/bills/Reports';
import NuevoQuickly from '../views/prebills/NuevoQuickly';
import ItemsMasVendidos from '../views/reports/ItemsMasVendidos';
import Convertions from '../views/products/Convertions';
import PurchasePending from '../views/purchases/PurchasePending';
import TopBestClients from './home/TopBestClients';
import TopBestClients2 from './home/TopBestClients2';

function Layout(props) {
    const { headerLayout } = props;

    const PrintCatalogos = catalogos.map(c => {
        return  <PrivateRoute key={c.name} exact path={`${_path.ROOTMAIN}/${c.name}`} render={(props) => (
                    <Catalogo {...props} {...c} />
        )} />
    });

    let prop = (path, component) => ({exact:true, path : `${_path.ROOTMAIN}/${path}`, component });

    const builRoute = (path, component) => <PrivateRoute key={path} {...prop(path, component) } /> ;

    const routes = [
        builRoute('', HomePage)     
        ,builRoute('areas', Areas)     
        ,builRoute('clasificaciones', Clasifications)     
        ,builRoute('paciente/:id', Paciente)       
        ,builRoute(`products/get/image/:id`, ImageProduct)       
        ,builRoute('facturas', Bills)       
        ,builRoute('notascreditos', NotasCreditos)       
        ,builRoute('cotizaciones', Cotizaciones)
        ,builRoute('pre-ventas', PreVentas)
        ,builRoute('pre-venta-quickly', NuevoQuickly)
        ,builRoute('mobile/cotizaciones', MobileCotizaciones)
        ,builRoute('mobile/pre-ventas', MobilePreVentas)
        ,builRoute('facturas-updates', BillUpdates)       
        ,builRoute('inventario/reportes/mov-productos', ItemsMasVendidos)
        ,builRoute('vendedores', Vendors)       
        ,builRoute('recibos', Receipts)       
        ,builRoute('clientes', Clients)       
        ,builRoute('goals', Goals)       
        ,builRoute('mobile/clientes', ClientsMobile)       
        ,builRoute('clientes/pending', Pending)       
        ,builRoute('clientes/mora', Mora)       
        ,builRoute('clientes/historial', Historial)       
        ,builRoute('clientes/mobile/pending', MobilePending)       
        ,builRoute('movimientos/entradas', initAdjustments)
        ,builRoute('movimientos/salidas', OutPutProducts)
        //,builRoute('movimientos/entradas', InPutProducts)
        ,builRoute('movimientos/inv-inicial', initProduct)
        ,builRoute('compras', Purchases)
        ,builRoute('productos', Products)
        ,builRoute('productos/conversiones', Convertions)
        ,builRoute('tasa-de-cambio', Rates)
        ,builRoute('proveedores', Providers)
        ,builRoute('usuarios', Users)
        ,builRoute('roles', Roles)
        ,builRoute('facturas/reportes/ventas', ReporteTabs)
        ,builRoute('facturas/reportes/recibos', Recibos)
        ,builRoute('facturas/reportes/dashboard', DashboardSales)
        ,builRoute('permisos', Resources)
        ,builRoute('inventario/reportes/kardex', Kardex)
        ,builRoute('inventario/reportes/existencias', Existencias)
        ,builRoute('inventario/reportes/existencias-fecha', StockByDate)
        ,builRoute('inventario/reportes/stock', Stock)
        ,builRoute('inventario/reportes/ingresos', Ingresos)
        ,builRoute('facturas/reportes/comisiones', Comision)
        ,builRoute('facturas/reportes/productos-consolidados', ProductsInfo)
        ,builRoute('cierres-caja', Cuts)
        ,builRoute('cierre/ejecute', Ejecute)
        ,builRoute('compras/reportes/', Compras)
        ,builRoute('compras/reportes/cxp', PurchasePending)
        ,builRoute('authorizations', Authorizations)
        ,builRoute('gastos', Expenses)
        ,builRoute('EstadoResultados', ResultStete)

        ,builRoute('navig', Navig)
        ,builRoute('config', AppConfig)
        ,builRoute('comission-config', ComisionFamilies)
        ,builRoute('top-best-client', TopBestClients2)

    ];
    return (
        <React.Fragment>          

            <ToastContainer autoClose={5000} hideProgressBar />

            <MobileMenu layout={headerLayout}/>

            <div className="site">
                <header className="site__header d-lg-none">
                    <MobileHeader />
                </header>

                <header className="site__header d-lg-block d-none">
                    <Header layout={headerLayout} />
                </header>

                <div className="site__body">
                
                    <Switch>
                        {PrintCatalogos}    
                        {routes}   
                        <PrivateRoute key={1} exact path={`${_path.ROOTMAIN}/movimientos/traslados`} render={props => <Traslates {...props} type={typeTraslate.create} /> } />                         
                        <PrivateRoute key={2} exact path={`${_path.ROOTMAIN}/movimientos/despacho`} render={props => <Traslates {...props} type={typeTraslate.update}/> } />                            

                    </Switch>
                </div>

                <footer className="site__footer">
                    <Footer showInfo={true} />
                </footer>
            </div>
        </React.Fragment>

    )
}

export default Layout;

